import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OfflinePatientsComponent } from './offline-patients/offline-patients.component';
import { OfflinePatientComponent } from './patient/offline-patient.component';

const routes: Routes = [
  {
    path: 'patients',
    component: OfflinePatientsComponent
  },
  {
    path: 'patient/:id',
    component: OfflinePatientComponent
  },
  {
    path: '',
    redirectTo: 'patients',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OfflineRoutingModule { }